<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<div>
  <div class="row">
    <div class="col-2">
      <label :for="id + '-input'" class="mt-2 float-right"><strong>{{label}}</strong></label>
    </div>
    <div class="col">
      <b-input-group>
        <b-form-input :list="id + '-list'" :id="id + '-input'" :placeholder="placeholder" v-model="inputValue" @input="resetError()" @keydown.native.enter.prevent="addItem()"></b-form-input>
        <datalist :id="id + '-list'">
          <option v-for="option in options" v-bind:key="option">{{option}}</option>
        </datalist>
        <b-input-group-append>
          <b-button variant="success" @click="addItem()">{{buttonText}}</b-button>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="inputError">{{inputError}}</span>
    </div>
  </div>
  <div class="row mb-3 mt-1">
    <div class="col offset-2">
      <b-badge variant="primary" v-for="value in values" size="lg" v-bind:key="value" class="mr-1">
        {{value}}
        <span class="pointer" @click="removeItem(value)">&times;</span>
      </b-badge>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    id: String,
    values: Array,
    options: Array,
    label: String,
    placeholder: String,
    buttonText: String,
  },
  data() {
    return {
      inputValue: null,
      inputError: null,
    }
  },
  methods: {
    addItem() {
      if (this.options.indexOf(this.inputValue) === -1) {
        this.inputError = "Please select one of the available values from the list";
        return;
      }
      const index = this.values.indexOf(this.inputValue);
      if (index === -1) {
        this.values.push(this.inputValue);
      }
      this.inputError = null;
      this.inputValue = null;
    },
    resetError() {
      this.inputError = null;
    },
    removeItem(value) {
      const index = this.values.indexOf(value);
      if (index > -1) {
        this.values.splice(index, 1);
      }
    }
  }
}
</script>
